import { Column, Typography } from '@/components'
import { Breakpoint, ThemeColor } from '@/enums'
import { themeBreakpointUp, toThemePixels } from '@/utils'
import { Button } from '@surein/ui'
import { ArrowRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'
import { ifProp } from 'styled-tools'

const fixedStyles = css`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
`

export const FixedFooter = styled.div<{ fixed?: boolean }>`
  background: #fff;
  padding: 16px;
  box-shadow: 0 -1px 1px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 ${toThemePixels(4)} ${toThemePixels(4)};

  align-items: center;
  justify-content: flex-end;
  display: flex;

  ${ifProp('fixed', fixedStyles)}
`

export const StepContainer = styled.div`
  > form {
    display: flex;
    height: calc(100vh - 90px);
    height: calc(100dvh - 90px);
    flex-direction: column;
  }

  ${themeBreakpointUp(Breakpoint.md)} {
    > form {
      height: 77vh;
    }
  }
`

export const FormContent = styled.div`
  overflow: auto;
  padding: 0 24px 24px 24px;

  flex: 1;
`
const StepHeaderContainer = styled(Column)`
  gap: 8px;
  padding: 24px;
`

interface StepHeaderProps {
  sectionLabel?: string
  title: string
  description?: string
}

export const StepHeader = ({
  sectionLabel,
  title,
  description,
}: StepHeaderProps) => (
  <StepHeaderContainer>
    <Typography color={ThemeColor.b50} variant="p1Body">
      {sectionLabel}
    </Typography>
    <Typography bold variant="h4">
      {title}
    </Typography>
    <Typography color={ThemeColor.b50} variant="p2Body">
      {description}
    </Typography>
  </StepHeaderContainer>
)

interface StepFooterProps {
  onSubmit: () => void
  isDisabled?: boolean
  onSubmitLabel?: string
  fixed?: boolean
  isButtonLoading: boolean
}

export const StepFooter = ({
  onSubmit,
  isDisabled,
  onSubmitLabel,
  fixed,
  isButtonLoading,
}: StepFooterProps) => {
  const { t } = useTranslation()
  return (
    <FixedFooter fixed={fixed}>
      <Button
        disabled={isDisabled}
        suffixIcon={ArrowRight}
        loading={isButtonLoading}
        onClick={onSubmit}
        shape="square"
        variant="primary"
      >
        {onSubmitLabel ?? t('yearlyAssessment.confirmAndContinue')}
      </Button>
    </FixedFooter>
  )
}
